import { Component, OnInit } from '@angular/core';
import {DataService} from '../../services/data.service';
declare var $: any;
@Component({
  selector: 'app-fraud-timeline-data',
  templateUrl: './fraud-timeline-data.component.html',
  styleUrls: ['./fraud-timeline-data.component.scss']
})
export class FraudTimelineDataComponent implements OnInit {
  radioValue: any;
  constructor(private dataService: DataService) {
  }

  ngOnInit() {
    this.radioValue = '0';
    this.dataService.fraudmessage.emit({ value: this.radioValue, remove: true });
  }
  sendValue(e) {
    this.radioValue = e.target.value;
    this.dataService.fraudmessage.emit({ value: this.radioValue, remove: true });
  }
  showModal(from, align) {
    const type = 'warning';
    $.notify({
      icon: 'notifications',
      message: 'Under Contruction, We will notify as soon as this functionality is added'
    }, {
      type: type,
      timer: 1000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}
